import tw from "twin.macro";
const PanelsGrid = tw.div`grid grid-cols-1 gap-6`;
export default PanelsGrid;
